import React, { useEffect } from 'react';

const TransparencySlider = ({ globalState, globalRefs, mapRef }) => {
  const polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
  const globalPolygonTransparency = globalState.globalPolygonTransparency;
  const setGlobalPolygonTransparency = globalState.setGlobalPolygonTransparency;
  const multuGroupSelectedArray = globalState.multuGroupSelectedArray;

  useEffect(() => {
    if (polygonCustomLayerRef.current) {
      polygonCustomLayerRef.current.setTransparency(globalPolygonTransparency);
    }
  }, [globalPolygonTransparency]);

  useEffect(() => {
    if (multuGroupSelectedArray.length === 0) {
      setGlobalPolygonTransparency(1);
    }
  }, [multuGroupSelectedArray]);

  const handleTransparencyChange = (e) => {
    const value = e.target.value;
    const normalized = 1 - value / 100;

    setGlobalPolygonTransparency(normalized);

    if (polygonCustomLayerRef.current) {
      polygonCustomLayerRef.current.setTransparency(normalized);
    }
  };

  return (
    <div
      style={{
        width: '100%',
        backgroundColor: 'transparent',
      }}
    >
      <div
        style={{
          textAlign: 'left',
          marginBottom: '4px',
          fontSize: '11px',
          color: '#687975',
        }}
      >
        <b>Transparency:</b>
      </div>

      <input
        type="range"
        min="0"
        max="100"
        value={(1 - globalPolygonTransparency) * 100}
        onChange={handleTransparencyChange}
        style={{
          width: '100%',
          margin: 0,
        }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: '10px',
          marginTop: '2px',
          color: '#687975',
        }}
      >
        <span>0</span>
        <span>1</span>
      </div>
    </div>
  );
};

export default TransparencySlider;
